
export const HIDDEN_TEASER_FIELDS = new Set([
    'createdAt',
    'updatedAt',
    'version',
    'duplicatedFrom',
    'createdBy',
    'updatedBy',
    'createdByAnonymizedUser',
    'updatedByAnonymizedUser',
    'responsible',
    'watchers',
    'contextOptions',
    'executedWorkflows',
    'legacyImportId',
    'searchScore',
    'disallowedProperties',
    'owners',
    'archived',
    'titleWithTourNumber',
    'nextDefault',
    'publish',
    'alwaysDisplayInSearch',
    'publishDate',
    'websites',
    'etag',
    'contingentExpirationRules',
    'contingentArrivalBased',
    'shortNoticeDays',
    'hasMarginTax',
    'boost',
    'randomHotel',
    'randomHotelOrder',
    'serviceType',
    'contingentBy',
    'pricePerDay',
    'cheapestLocalPayment',
    'cheapestLocalPaymentCurrency',
    'hasGuaranteedJourney',
    'bookingCount',
    'lastCalculated',
    'individualParticipantCount',
    'seasonPrices',
    'excludeFromInsuranceCoverage',
    'excludeFromPricingRules',
    'additionalOptions',
    'idCardAllowed',
    'passportScanRequired',
    'passportImageRequired',
    'defaultCommissionReceiver',
    'copyCalculations',
    'synchronizedAt',
    'noIndex',
    'faq',
    'registrationListAgencies',
    'aerFlightTariffs',
    'aerClosedUserGroups',
    'aerTariffByState',
    'accommodationPerType',
    'paxloungeUseFlightSearch',
    'paxLoungeTotalPriceCurrency',
    'allowedAirlines',
    'flightOnDemand',
    'paybackIncludedFlightPrice',
    'maxFlightTime',
    'maxSegments',
    'enableFitFlightSelection',
    'includedFlightPrice',
    'forbiddenArrivalTypes',
    'pickupArrivalTypes',
    'deactivateArrivalTypes',
    'includedInsurance',
    'importedId',
    'importedVariationIds',
    'importedJourneyNumber',
    'importedTitle',
    'importedLink',
    'importDiscounts',
    'importedTeaser',
    'importedHighlights',
    'importedMap',
    'importedTourDossier',
    'importedRoom',
    'surveyParticipantQuestionTemplate',
    'surveyParticipantEmailTemplate',
    'agenciesAllowed',
    'agenciesNotAllowed',
    'allowBookingWithoutAgency',

    'displayInSearch',
    'hideFromSearchSinceDate',
    'hideFromSearchReason',

    'staticGiataId',
    'overwriteStaticGiataId',
    'overwriteCityId',
    'crsServiceType',
    'crsDestinationAirport',
    'deviatingDepartureHarbour',
    'deviatingArrivalHarbour',
    'guideDifferentSplitPoint',
    'guideProvider',
    'allowedDepartureAirports',
    'maxFlightTravelTime',

    'calculations',
    'calculationServices',
    'busRoutingSettings',
    'busRoutingManagers',
    'serviceProvider',

    // SEO / presentation
    'cooperationPartnerUrl',
    'metaTitle',
    'metaDescription',
    'days',
    'presentationFields',
    'reservedParticipants',
    'overwriteDayAttributes',

    // Participant forms
    'participantDataFormTemplateAgencyCollection',
    'participantDataFormTemplateOtherPayment',
    'directions',
    'directionsHash',

    // OCR / casing variants (API key spelling can differ)
    'legacylmportld',
    'passportlmageRequired',
    'nolndex',
    'importedld',
    'importedVariationlds',
    'staticGiatald',
    'overwriteStaticGiatald',
    'overwriteCityld',
    'paybackincludedFlightPrice',
    'includedinsurance',

    'nameSlug',
    'default'
]);
